(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rehabeshop-activity-popup"] && !Shopify.designMode) return;
  try {
    const initialiseActivityPopups = () => {
    document.querySelectorAll('[data-rehabeshop-activity-popup]').forEach((popup) => {
      if (popup.dataset.initialised === 'true') return;

      popup.dataset.initialised = 'true';

      let products = [];
      const productData = popup.querySelector('[data-activity-popup-products]');

      try {
        products = JSON.parse(productData?.textContent || '[]');
      } catch {
        products = [];
      }

      if (products.length === 0) return;

      const cities = [
        'Sydney',
        'Melbourne',
        'Brisbane',
        'Perth',
        'Adelaide',
        'Gold Coast',
        'Canberra',
        'Newcastle',
        'Wollongong',
        'Geelong',
        'Hobart',
        'Darwin',
        'Cairns',
        'Townsville',
        'Toowoomba',
        'Ballarat',
        'Bendigo',
        'Launceston',
        'Mackay',
        'Rockhampton',
        'Bunbury',
        'Mandurah',
        'Albany',
        'Geraldton',
        'Alice Springs'
      ];

      const messages = Array.from({ length: 100 }, (_, index) => ({
        city: cities[index % cities.length],
        product: products[index % products.length]
      }));

      for (let index = messages.length - 1; index > 0; index -= 1) {
        const randomIndex = Math.floor(Math.random() * (index + 1));
        [messages[index], messages[randomIndex]] = [messages[randomIndex], messages[index]];
      }

      const link = popup.querySelector('[data-activity-popup-link]');
      const location = popup.querySelector('[data-activity-popup-location]');
      const product = popup.querySelector('[data-activity-popup-product]');
      const close = popup.querySelector('[data-activity-popup-close]');
      const prefix = popup.dataset.prefix;
      const storageKey = 'rehabeshopActivityPopupClosed';
      let messageIndex = 0;
      let initialTimer;
      let cycleTimer;
      let hideTimer;
      let hiddenTimer;

      const isClosed = () => {
        try {
          return sessionStorage.getItem(storageKey) === 'true';
        } catch {
          return false;
        }
      };

      const hidePopup = () => {
        popup.classList.remove('is-visible');
        hiddenTimer = window.setTimeout(() => {
          popup.hidden = true;
        }, 180);
      };

      const showPopup = () => {
        if (isClosed()) return;

        const message = messages[messageIndex % messages.length];
        messageIndex += 1;

        location.textContent = `${prefix} ${message.city}`;
        product.textContent = message.product.title;
        link.href = message.product.url;
        link.setAttribute('aria-label', `${prefix} ${message.city}: ${message.product.title}`);

        window.clearTimeout(hiddenTimer);
        popup.hidden = false;
        window.requestAnimationFrame(() => popup.classList.add('is-visible'));
        window.clearTimeout(hideTimer);
        hideTimer = window.setTimeout(hidePopup, 2000);
      };

      const closePopup = () => {
        try {
          sessionStorage.setItem(storageKey, 'true');
        } catch {
          popup.dataset.closed = 'true';
        }

        window.clearTimeout(initialTimer);
        window.clearInterval(cycleTimer);
        window.clearTimeout(hideTimer);
        window.clearTimeout(hiddenTimer);
        popup.classList.remove('is-visible');
        popup.hidden = true;
      };

      close.addEventListener('click', closePopup);

      if (isClosed()) return;

      initialTimer = window.setTimeout(showPopup, 1500);
      cycleTimer = window.setInterval(showPopup, 5000);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseActivityPopups, { once: true });
  } else {
    initialiseActivityPopups();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rehabeshop-quote-basket"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.querySelector('[data-quote-root]');
  if (!root) return;
  const key = 'rehabeshop-quote-v1';
  let items = [];
  try { items = JSON.parse(localStorage.getItem(key) || '[]'); } catch (_) {}
  if (!Array.isArray(items)) items = [];
  const dialog = root.querySelector('[data-quote-dialog]');
  const list = root.querySelector('[data-quote-items]');
  const counts = document.querySelectorAll('[data-quote-count]');
  const empty = root.querySelector('[data-quote-empty]');
  const toast = root.querySelector('[data-quote-toast]');
  const form = root.querySelector('form');
  const save = () => { localStorage.setItem(key, JSON.stringify(items)); render(); };
  const render = () => {
    counts.forEach(count => { count.textContent = String(items.reduce((sum, item) => sum + item.quantity, 0)); });
    empty.hidden = items.length > 0;
    list.replaceChildren();
    for (const item of items) {
      const row = document.createElement('div');
      row.className = 'rehab-quote__item';
      const link = document.createElement('a');
      link.href = item.url;
      link.textContent = item.title + (item.variantTitle && item.variantTitle !== 'Default Title' ? ' — ' + item.variantTitle : '');
      const qty = document.createElement('input');
      qty.type = 'number'; qty.min = '1'; qty.max = '999'; qty.value = item.quantity;
      qty.setAttribute('aria-label', root.dataset.quoteQuantity + ' for ' + item.title);
      qty.addEventListener('change', () => { item.quantity = Math.max(1, Math.min(999, parseInt(qty.value, 10) || 1)); save(); });
      const remove = document.createElement('button');
      remove.type = 'button'; remove.textContent = root.dataset.quoteRemove;
      remove.addEventListener('click', () => { items = items.filter(entry => entry !== item); save(); });
      row.append(link, qty, remove); list.append(row);
    }
  };
  render();
  if (root.querySelector('[data-quote-success]')) { items = []; save(); dialog.showModal(); }
  document.addEventListener('click', (event) => {
    const add = event.target.closest('[data-quote-add]');
    if (add) {
      event.preventDefault();
      const productForm = add.closest('product-form-component');
      const formElement = productForm && productForm.querySelector('form');
      const variantId = formElement && formElement.querySelector('input[name="id"]')?.value;
      if (!variantId) return;
      let variants = [];
      try { variants = JSON.parse(add.dataset.variants || '[]'); } catch (_) {}
      const variant = variants.find(entry => String(entry.id) === String(variantId));
      const quantity = Math.max(1, parseInt(formElement.querySelector('[name="quantity"]')?.value || '1', 10) || 1);
      const existing = items.find(item => item.variantId === variantId);
      if (existing) existing.quantity += quantity;
      else items.push({ variantId, title: add.dataset.productTitle, variantTitle: variant?.title || '', url: add.dataset.productUrl, quantity });
      save();
      toast.textContent = root.dataset.quoteAdded;
      toast.hidden = false;
      clearTimeout(root.toastTimer);
      root.toastTimer = setTimeout(() => { toast.hidden = true; }, 4000);
    }
    if (event.target.closest('[data-quote-add-cart]')) {
      event.preventDefault();
      fetch((window.Shopify?.routes?.root || '/') + 'cart.js')
        .then(response => { if (!response.ok) throw new Error('cart'); return response.json(); })
        .then(cart => {
          for (const line of cart.items) {
            const variantId = String(line.variant_id);
            const existing = items.find(item => item.variantId === variantId);
            if (existing) existing.quantity = Math.max(existing.quantity, line.quantity);
            else items.push({ variantId, title: line.product_title, variantTitle: line.variant_title || '', url: line.url, quantity: line.quantity });
          }
          save(); dialog.showModal();
        })
        .catch(() => { toast.textContent = root.dataset.quoteCartError; toast.hidden = false; });
    }
    if (event.target.closest('[data-quote-open]')) {
      const drawer = event.target.closest('header-drawer');
      if (drawer) drawer.querySelector('details')?.removeAttribute('open');
      dialog.showModal();
    }
    if (event.target.closest('[data-quote-close]')) dialog.close();
  });
  form.addEventListener('submit', (event) => {
    const error = root.querySelector('[data-quote-error]');
    if (!items.length) { event.preventDefault(); error.hidden = false; return; }
    error.hidden = true;
    const postcode = root.querySelector('[data-quote-postcode]').value.trim();
    const organisation = root.querySelector('[data-quote-organisation]').value.trim();
    const notes = root.querySelector('[data-quote-notes]').value.trim();
    root.querySelector('[data-quote-body]').value = [
      'Rehabeshop quotation request',
      '',
      ...items.map((item, index) => (index + 1) + '. ' + item.title + (item.variantTitle && item.variantTitle !== 'Default Title' ? ' / ' + item.variantTitle : '') + ' | variant ID: ' + item.variantId + ' | Qty: ' + item.quantity + ' | ' + new URL(item.url, location.origin).href),
      '',
      'Delivery postcode: ' + postcode,
      'Business or organisation: ' + (organisation || 'Not provided'),
      'Notes: ' + (notes || 'None')
    ].join('\n');
  });
})();
  } catch(e) { console.error(e); }
})();

})();
